import React, { useState, useEffect } from "react";
import { CustomAutoComplete } from "components/CustomComponents";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";
import { CustomTextBox } from "components/CustomComponents";
import { useForm } from "react-hook-form";
import {
  CustomButtonWithBorder,
  CustomButton,
} from "components/CustomComponents/CustomButton";
import { payCycle } from "pages/PayRoll/PayRollHeaders";
import { weekDays } from "pages/PayRoll/PayRollHeaders";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { CustomizedDatePicker } from "components/CustomComponents/CustomizedDatePicker";
import { customAPI } from "services/utils/CustomAPI";
import {
  getOrdinal,
  themes,
  parentBoxStyle,
  childBoxStyleWithColor,
  infoStyle,
  toAlignEnd,
  nameLength,
} from "services/constants";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import dayjs from "dayjs";
import { paymentOptions } from "pages/PayRoll/PayRollHeaders";
import { cardStyle } from "pages/HR/Shift/Configuration/ShiftCategory/Component/ShiftCategoryOptions";

export const EditPayRunCycle = ({
  onClose,
  reCallApi,
  payCycleDetails,
  setGetId,
  setPayrunViewedItem,
  setHasUnsavedChanges,
  setIsEditPanelOpen,
}) => {
  const {
    setValue,
    handleSubmit,
    register,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      pay_cycle: "",
      days_of_week_name: "",
      date_of_month: "1",
      first_half_start_day: "1",
      first_half_end_day: "15",
      second_half_start_day: "16",
      second_half_end_day: "31",
      first_half_end_day_month: "respective",
      fixed_month_second_half_end_month: "respective",
      payrun_cycle_name: "",
      payrun_start_date: dayjs(),
      payrun_end_date: dayjs(),
      payment_based_on: "Shift",
    },
  });
  const { domain } = useSelector((state) => state.tokenReducer);
  const [isAutoName, setIsAutoName] = useState(false);
  const payCycleName = watch("pay_cycle");
  const dayOfWeek = watch("days_of_week_name");
  const dayOfMonth = watch("date_of_month");
  const startDate = watch("payrun_start_date");
  const firstHalfStartDay = watch("first_half_start_day");
  const firstHalfEndDay = watch("first_half_end_day");
  const secondHalfStartDay = watch("second_half_start_day");
  const secondHalfEndDay = watch("second_half_end_day");
  const dayAndMonth = dayjs(startDate).isValid()
    ? dayjs(startDate).format("DD MMM")
    : "";
  const endDate = watch("payrun_end_date");
  const dayOfMonthEnd = dayjs(endDate).isValid()
    ? dayjs(endDate).format("DD MMM")
    : "";

  const [initialFormValues, setInitialFormValues] = useState(null);
  const formValues = watch();
  const deepEqual = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  };

  useEffect(() => {
    if (payCycleDetails && !initialFormValues) {
      const defaultValues = {
        pay_cycle: payCycleDetails?.pay_run_cycle_type || "",
        days_of_week_name: payCycleDetails?.start_day || "Monday",
        date_of_month: payCycleDetails?.date_of_month || "1",
        first_half_start_day: payCycleDetails?.first_half_start_day || "1",
        first_half_end_day: payCycleDetails?.first_half_end_day || "15",
        second_half_start_day: payCycleDetails?.second_half_start_day || "16",
        second_half_end_day: payCycleDetails?.second_half_end_day || "31",
        first_half_end_day_month:
          payCycleDetails?.first_half_start_day >
          payCycleDetails?.first_half_end_day
            ? "next"
            : "respective",
        fixed_month_second_half_end_month:
          payCycleDetails?.first_half_start_day === 1 ? "respective" : "next",
        payrun_cycle_name: payCycleDetails?.name || "",
        payrun_start_date: payCycleDetails?.start_date
          ? dayjs(payCycleDetails?.start_date.split("-").reverse().join("-"))
          : null,
        payrun_end_date: payCycleDetails?.end_date
          ? dayjs(payCycleDetails?.end_date.split("-").reverse().join("-"))
          : null,
        payment_based_on: payCycleDetails?.payment_basis,
      };

      setInitialFormValues(defaultValues);
      reset(defaultValues);
    }
  }, [payCycleDetails, initialFormValues, reset]);

  useEffect(() => {
    if (initialFormValues && formValues) {
      const hasChanges = !deepEqual(formValues, initialFormValues);
      setHasUnsavedChanges(hasChanges);
    }
  }, [formValues, initialFormValues, setHasUnsavedChanges]);

  useEffect(() => {
    if (isAutoName) {
      let autoName = "";

      switch (payCycleName) {
        case "Weekly":
          autoName = dayOfWeek
            ? `Weekly-${dayOfWeek}-${dayAndMonth}`
            : "Weekly Payrun Cycle";
          break;
        case "Bi-Weekly":
          autoName = dayOfWeek
            ? `Bi-Weekly-${dayOfWeek}-${dayAndMonth}`
            : "Bi-Weekly Payrun Cycle";
          break;
        case "Monthly":
          autoName = `Monthly-${getOrdinal(
            dayOfMonth || 1
          )} Day-${dayAndMonth}`;
          break;
        case "Semi-Monthly":
          autoName = `Semi-Monthly-${firstHalfStartDay}-${firstHalfEndDay}-${secondHalfStartDay}-${secondHalfEndDay}-${dayAndMonth}`;
          break;
        case "Custom":
          autoName = `Custom-${dayAndMonth}-${dayOfMonthEnd}`;
          break;
        default:
          autoName = "";
      }

      setValue("payrun_cycle_name", autoName);
    }
  }, [
    dayOfWeek,
    dayOfMonth,
    isAutoName,
    setValue,
    payCycleName,
    dayAndMonth,
    firstHalfStartDay,
    firstHalfEndDay,
    secondHalfStartDay,
    secondHalfEndDay,
    dayOfMonthEnd,
  ]);

  const handlepaycycle = (event, data) => {
    if (data) {
      setIsAutoName(true);
      setValue("pay_cycle", data.label);
      setValue("days_of_week_name", "Monday");
      setValue("date_of_month", "1");
      setValue("date_of_month", "1");
      setValue("first_half_start_day", "1");
      setValue("first_half_end_day", "15");
      setValue("second_half_start_day", "16");
      setValue("second_half_end_day", "31");
    } else {
      setValue("pay_cycle", "");
    }
  };

  const hanldePaymentBasedOn = (event) => {
    setValue("payment_based_on", event.target.value);
  };

  const handleDaysOfWeeKName = (event, data) => {
    if (data) {
      setValue("days_of_week_name", data.label);
      setIsAutoName(true);
    } else {
      setValue("days_of_week_name", "");
    }
  };

  const handleDaysOfMonth = (event) => {
    if (
      /^(?:[1-9]|1[0-9]|2[0-8])$/.test(event.target.value) ||
      event.target.value === ""
    ) {
      setValue("date_of_month", event.target.value);
    } else {
      setValue("date_of_month", "");
    }
  };

  const handleFirstHalfStartDay = (event) => {
    if (
      /^(?:[1-9]|1[0-9]|2[0-8])$/.test(event.target.value) ||
      event.target.value === ""
    ) {
      setValue("first_half_start_day", event.target.value);
      if (event.target.value === "1") {
        setValue("second_half_end_day", "31");
        setValue("fixed_month_second_half_end_month", "respective");
      } else {
        if (event.target.value === "") {
          setValue("second_half_end_day", "");
          setValue("second_half_start_day", "");
        } else {
          setValue("second_half_end_day", parseInt(event.target.value) - 1);
          setValue("fixed_month_second_half_end_month", "next");
        }
      }
      setValue("first_half_end_day", "");
    }
  };

  const handleFirstHalfEndDay = (event) => {
    if (
      /^(?:[1-9]|1[0-9]|2[0-7])$/.test(event.target.value) ||
      event.target.value === ""
    ) {
      setValue("first_half_end_day", event.target.value);
      if (event.target.value === "28") {
        setValue("second_half_start_day", "1");
      } else if (event.target.value !== "") {
        setValue("second_half_start_day", parseInt(event.target.value) + 1);
      }
      if (
        event.target.value !== "" &&
        parseInt(watch("first_half_start_day")) >
          parseInt(event.target.value || 0)
      ) {
        setValue("first_half_end_day_month", "next");
      } else if (event.target.value !== "") {
        setValue("first_half_end_day_month", "respective");
      } else if (event.target.value === "") {
        setValue("second_half_start_day", "");
      }
    }
  };

  const handlePayrunCycleName = (event) => {
    if (event.target.value.length <= nameLength) {
      setIsAutoName(false);
      setValue("payrun_cycle_name", event.target.value);
    }
  };

  const onSubmit = async (data) => {
    setValue("button_loader", true);
    let payload = {
      pay_run_cycle_type: data?.pay_cycle,
      name: data?.payrun_cycle_name,
      start_date: data?.payrun_start_date.format("YYYY-MM-DD"),
      next_pay_run_date: data?.payrun_start_date.format("YYYY-MM-DD"),
      payment_basis: watch("payment_based_on"),
      company_ids: [payCycleDetails?.company],
    };

    switch (data.pay_cycle) {
      case "Weekly":
      case "Bi-Weekly":
        payload = {
          ...payload,
          start_day: data?.days_of_week_name,
        };
        break;

      case "Monthly":
        payload = {
          ...payload,
          date_of_month: data?.date_of_month,
        };
        break;

      case "Semi-Monthly":
        payload = {
          ...payload,
          first_half_start_day: parseInt(data?.first_half_start_day),
          first_half_end_day: parseInt(data?.first_half_end_day),
          second_half_start_day: data?.second_half_start_day,
          second_half_end_day: data?.second_half_end_day,
        };
        break;

      case "Custom":
        payload = {
          ...payload,
          end_date: data?.payrun_end_date.format("YYYY-MM-DD"),
        };
        break;

      default:
        break;
    }

    const response = await customAPI(
      `${domain}payroll/setup/payruncycle/pay-run-cycles/${payCycleDetails?.id}`,
      "PUT",
      payload
    );
    if (response.ok) {
      setHasUnsavedChanges(false);
      setGetId(payCycleDetails?.id);
      showToast("success", "Payrun cycle details updated successfully");
      setPayrunViewedItem(true);
      setValue("button_loader", false);
      setIsEditPanelOpen(false);
      reCallApi(true);
    } else {
      setValue("button_loader", false);
      showToast("error", response?.message);
    }
  };

  return (
    <Box sx={parentBoxStyle}>
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box sx={childBoxStyleWithColor}>
          <Box sx={{ ml: 1 }}>
            <IconButton
              onClick={onClose}
              sx={{
                color: themes?.grayColor,
                "&:hover": {
                  backgroundColor: themes?.whiteColor,
                },
              }}
            >
              <DoubleArrow />
            </IconButton>
          </Box>

          <Box sx={{ ml: 2.2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Edit Payrun Cycle
            </Typography>
            <Typography {...infoStyle}>
              Edit your payroll cycle by defining the pay period.
            </Typography>
          </Box>
        </Box>
      </Paper>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              ml: 1.5,
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Company Name</Typography>
              <Typography {...infoStyle}>
                Select the company for which this payrun cycle appliess
              </Typography>
              <CustomTextBox
                selectedValue={payCycleDetails?.company_name}
                disabledValue={true}
              />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Pay Cycle Frequency
              </Typography>
              <Typography {...infoStyle}>
                Select an existing pay cycle period to process employee
                payments.
              </Typography>
              <CustomAutoComplete
                dataList={payCycle}
                rules={{
                  ...register("pay_cycle", {
                    required: "Pay cycle frequency is required",
                  }),
                }}
                selectedValue={watch("pay_cycle")}
                updateDataFunction={handlepaycycle}
                placeHolder="Select pay cycle frequency"
                errorMessage={
                  errors?.pay_cycle?.message ? errors?.pay_cycle?.message : ""
                }
                textBoxError={errors?.pay_cycle ? true : false}
              />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Payment calculation based on
              </Typography>
              <Typography {...infoStyle}>
                Choose whether to calculate pay by shift or hours for this pay
                period.
              </Typography>

              <RadioGroup
                row
                value={watch("payment_based_on")}
                onChange={hanldePaymentBasedOn}
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                {paymentOptions.map((opt) => {
                  const isActive = watch("payment_based_on") === opt.id;
                  return (
                    <Box key={opt.id} sx={cardStyle(isActive)}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Radio value={opt.id} />
                        <Typography
                          fontWeight={"medium"}
                          sx={{
                            color:
                              watch("payment_based_on") === opt.id
                                ? themes?.stepActiveColor
                                : "inherit",
                          }}
                        >
                          {opt.label}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          marginLeft: "32px",
                          maxWidth: 250,
                          wordBreak: "break-word",
                        }}
                      >
                        {opt.description}
                      </Typography>
                    </Box>
                  );
                })}
              </RadioGroup>
            </Box>
            {watch("pay_cycle") !== "Custom" &&
              watch("pay_cycle") !== "Semi-Monthly" && (
                <Box>
                  <Typography sx={{ fontWeight: 600 }}>
                    Start Day / Date
                  </Typography>
                  <Typography {...infoStyle}>
                    Select the day the pay period begins (e.g., Monday or 10th).
                  </Typography>
                  {watch("pay_cycle") !== "Monthly" && (
                    <CustomAutoComplete
                      dataList={weekDays}
                      rules={{
                        ...register("days_of_week_name", {
                          required:
                            watch("pay_cycle") === "Weekly" ||
                            watch("pay_cycle") === "Bi-Weekly" ||
                            watch("days_of_week_name") === ""
                              ? "Days of week name is required"
                              : false,
                        }),
                      }}
                      selectedValue={watch("days_of_week_name")}
                      updateDataFunction={handleDaysOfWeeKName}
                      placeHolder="Select pay cycle"
                      errorMessage={
                        errors?.days_of_week_name?.message
                          ? errors?.days_of_week_name?.message
                          : ""
                      }
                      textBoxError={errors?.days_of_week_name ? true : false}
                    />
                  )}
                  {watch("pay_cycle") === "Monthly" && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: "70%" }}>
                        <CustomTextBox
                          selectedValue={watch("date_of_month")}
                          rules={{
                            ...register("date_of_month", {
                              required:
                                watch("pay_cycle") === "Monthly"
                                  ? "Day of month is required"
                                  : false,
                            }),
                          }}
                          updateDataFunction={handleDaysOfMonth}
                          placeHolder="Enter day of month"
                          errorMessage={
                            errors?.date_of_month?.message
                              ? errors?.date_of_month?.message
                              : ""
                          }
                          textBoxError={errors.date_of_month ? true : false}
                        />
                      </Box>
                      <Typography sx={{ fontWeight: 500 }}>
                        day of respective month
                      </Typography>
                    </Box>
                  )}
                </Box>
              )}
            {watch("pay_cycle") === "Semi-Monthly" && (
              <>
                <Box>
                  <Typography
                    sx={{ fontWeight: 600, color: themes?.stepActiveColor }}
                  >
                    First Half
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
                      Start Day
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: "120px" }}>
                        <CustomTextBox
                          selectedValue={watch("first_half_start_day")}
                          rules={{
                            ...register("first_half_start_day", {
                              required:
                                watch("pay_cycle") === "Semi-Monthly"
                                  ? "First half start day is required"
                                  : false,
                            }),
                          }}
                          updateDataFunction={handleFirstHalfStartDay}
                          placeHolder="Enter day"
                          errorMessage={
                            errors?.first_half_start_day?.message
                              ? errors?.first_half_start_day?.message
                              : ""
                          }
                          textBoxError={
                            errors.first_half_start_day ? true : false
                          }
                        />
                      </Box>
                      <Typography sx={{ fontWeight: 500 }}>
                        day of respective month
                      </Typography>
                    </Box>
                  </Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
                      End Day
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: "120px" }}>
                        <CustomTextBox
                          selectedValue={watch("first_half_end_day")}
                          rules={{
                            ...register("first_half_end_day", {
                              required:
                                watch("pay_cycle") === "Semi-Monthly"
                                  ? "First half end day is required"
                                  : false,
                              validate: {
                                validateValue: (value) => {
                                  if (value) {
                                    if (
                                      watch("first_half_end_day_month") ===
                                        "respective" &&
                                      parseInt(value) <
                                        parseInt(watch("first_half_start_day"))
                                    ) {
                                      return "First half end date must be greater then first half start date";
                                    }
                                  }
                                },

                                validateValueAtleastSevenDay: (value) => {
                                  const circularDiff =
                                    parseInt(value) >=
                                    parseInt(watch("first_half_start_day"))
                                      ? parseInt(value) -
                                        parseInt(watch("first_half_start_day"))
                                      : 28 -
                                        parseInt(
                                          watch("first_half_start_day")
                                        ) +
                                        parseInt(value);
                                  if (circularDiff < 6) {
                                    return "The first half's end date must be greater than the start date by a minimum of 7 days.";
                                  }
                                },
                              },
                            }),
                          }}
                          updateDataFunction={handleFirstHalfEndDay}
                          placeHolder="Enter day"
                          errorMessage={
                            errors?.first_half_end_day?.message
                              ? errors?.first_half_end_day?.message
                              : ""
                          }
                          textBoxError={
                            errors.first_half_end_day ? true : false
                          }
                        />
                      </Box>
                      <Typography sx={{ fontWeight: 500 }}>
                        day of {watch("first_half_end_day_month")} month
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box>
                  <Typography
                    sx={{ fontWeight: 600, color: themes?.stepActiveColor }}
                  >
                    Second Half
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 2.5,
                  }}
                >
                  <Box>
                    <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
                      Start Day
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: "120px" }}>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: themes?.stepActiveColor,
                            fontSize: 23,
                          }}
                        >
                          {watch("second_half_start_day")
                            ? watch("second_half_start_day")
                            : "0"}
                        </Typography>
                      </Box>
                      <Typography sx={{ fontWeight: 500 }}>
                        day of {""}
                        {watch("first_half_end_day_month")} month
                      </Typography>
                    </Box>
                  </Box>

                  <Box>
                    <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
                      End Day
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: "120px" }}>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: themes?.stepActiveColor,
                            fontSize: 23,
                          }}
                        >
                          {watch("second_half_end_day")
                            ? watch("second_half_end_day")
                            : "0"}
                        </Typography>
                      </Box>
                      <Typography sx={{ fontWeight: 500 }}>
                        day of {watch("fixed_month_second_half_end_month")}{" "}
                        month
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            )}

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns:
                  watch("pay_cycle") === "Custom" ? "1fr 1fr" : "1fr",
                gap: 2,
              }}
            >
              <Box>
                <Typography sx={{ fontWeight: 600 }}>
                  {watch("pay_cycle") === "Custom"
                    ? "Start Date"
                    : "Payrun Starts On"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {watch("pay_cycle") === "Custom"
                    ? "Select the beginning date of the payroll calculation period."
                    : "Choose the date when the payroll calculation begins for this cycle."}
                </Typography>
                <CustomizedDatePicker
                  name="payrun_start_date"
                  control={control}
                  required
                  requiredMessage="Payrun start day is required"
                  placeholder="Select payrun cycle start date "
                  selectedWeekday={
                    watch("pay_cycle") === "Weekly" ||
                    watch("pay_cycle") === "Bi-Weekly"
                      ? dayOfWeek
                      : null
                  }
                  selectedDayOfMonth={
                    watch("pay_cycle") === "Monthly"
                      ? dayOfMonth
                      : watch("pay_cycle") === "Semi-Monthly"
                      ? firstHalfStartDay
                      : null
                  }
                  onChange={(newValue) => {
                    setValue("payrun_start_date", newValue);
                    setIsAutoName(true);
                  }}
                />
              </Box>
              {watch("pay_cycle") === "Custom" && (
                <Box>
                  <Typography sx={{ fontWeight: 600 }}>End Date</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Define when the payroll period ends for this cycle.
                  </Typography>
                  <CustomizedDatePicker
                    name="payrun_end_date"
                    control={control}
                    required={watch("pay_cycle") === "Custom"}
                    requiredMessage="Payrun end day is required"
                    placeholder="Select payrun cycle end date"
                    startDate={watch("payrun_start_date")}
                    onChange={(newValue) => {
                      setValue("payrun_end_date", newValue);
                      setIsAutoName(true);
                    }}
                  />
                </Box>
              )}
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                Payrun Cycle Name
              </Typography>
              <Typography {...infoStyle}>
                Auto-suggest a generated name below field — e.g., “Will be saved
                as: Monthly-10th-Day-S”
              </Typography>
              <CustomTextBox
                selectedValue={watch("payrun_cycle_name")}
                rules={{
                  ...register("payrun_cycle_name", {
                    required: "Payrun cycle name is required",
                    minLength: {
                      value: 3,
                      message: "Minium length is 3 characters",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={handlePayrunCycleName}
                placeHolder="Enter payrun cycle name"
                errorMessage={
                  errors?.payrun_cycle_name?.message
                    ? errors?.payrun_cycle_name?.message
                    : ""
                }
                textBoxError={errors.payrun_cycle_name ? true : false}
              />
            </Box>
            <Box sx={toAlignEnd}>
              <CustomButtonWithBorder
                actionName="Cancel"
                typeName="button"
                actionFuntion={() => onClose()}
              />
              <CustomButton
                actionFuntion={handleSubmit(onSubmit)}
                actionName="Update"
                typeName="submit"
                disableAction={watch("button_loader")}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
